<h2 mat-dialog-title>{{ data.titulo }}</h2>
<mat-dialog-content class="confirm-dialog__content mat-typography">
  <p>{{ data.mensagem }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Cancelar</button>
  <button
    mat-flat-button
    type="button"
    [color]="data.corConfirmar ?? 'primary'"
    [mat-dialog-close]="true"
  >
    {{ data.textoConfirmar }}
  </button>
</mat-dialog-actions>
